<pmd-navbar-brand *ngIf="invoiceData">
	<a class="navbar-brand d-flex align-items-center" href="#">
		<!-- <img src="assets/images/sample-logo.png" class="d-inline-block align-center" alt="M. A. Kharafi & Sons"> -->
			<span class="pmd-avatar pmd-avatar-secondary me-2">{{invoiceData.merchant_details.firstname.charAt(0).toUpperCase()}}{{invoiceData.merchant_details.lastname.charAt(0).toUpperCase()}}</span>
			<span class="h3 mb-0 text-primary">{{invoiceData.merchant_details.firstname}} {{invoiceData.merchant_details.lastname}}</span>
	</a>
</pmd-navbar-brand>

<h5 class="border-start mb-0 ps-3 d-none d-md-block" *ngIf="invoiceData">{{invoiceData.invoice_number}}</h5>

<pmd-navbar-right-icon class="d-flex align-items-center pf-navbar-right-icon">
	<button type="button" class="d-none d-md-block" pmdRipple pmd-btn-fab color="dark" pmd-btn-outline size="sm" (click)="print()">
		<i class="material-icons-round pmd-icon-xs">print</i>
	</button>
	<!-- <button  type="button" class="d-none d-md-block" pmdRipple pmd-btn-fab color="dark" pmd-btn-outline size="sm">
		<i class="material-icons-round pmd-icon-xs">download</i>
	</button>
	<button type="button" class="d-none d-md-block" pmdRipple pmd-btn-fab color="dark" pmd-btn-outline size="sm">
		<i class="material-icons-round pmd-icon-xs">print</i>
	</button>
	-->
	<div class="dropdown" pmdDropdown class="d-block d-md-none">
		<button type="button" pmdRipple pmd-btn-fab color="dark" pmd-btn-outline size="sm" class="dropdown-toggle" pmdDropdownToggle>
			<i class="material-icons-round pmd-icon-xs">more_vert</i>
		</button>
		<div class="dropdown-menu" *pmdDropdownMenu>
			<!-- <a class="dropdown-item d-flex flex-row align-items-center" href="#">
				<i class="material-icons-round">download</i>
				<span class="media-body">Download PDF</span>
			</a> -->
			<a class="dropdown-item d-flex flex-row align-items-center" href="#">
				<i class="material-icons-round">print</i>
				<span class="media-body">Print Invoice</span>
			</a>
		</div>
	</div> 
	<a class="secondary-brand" href="https://www.paykanz.com" target="_blank">
		<img src="assets/images/kanz-logo.png" class="fils-logo d-none d-md-block" alt="PayKanz" height="48">
		<img src="assets/images/kanz-icon.png" class="fils-logo-icon d-block d-md-none" alt="PayKanz" height="40">
	</a>
</pmd-navbar-right-icon>